import { CustomerOrderDetailPage, CustomerOrdersListPage } from '../components'
import type { CustomerProtectedRendererInput } from './types'

export const renderOrderRoutes = ({ onNavigate, viewModel }: CustomerProtectedRendererInput) => {
  const profile = viewModel.profile

  if (!profile) {
    return null
  }

  if (viewModel.isOrderDetailRoute) {
    return (
      <CustomerOrderDetailPage
        token={viewModel.token}
        profile={profile}
        orderDetailId={viewModel.orderDetailId}
        orderDetail={viewModel.orderDetail}
        orderDetailLoading={viewModel.orderDetailLoading}
        orderDetailError={viewModel.orderDetailError}
        orderInvoices={viewModel.orderInvoices}
        orderInvoicesLoading={viewModel.orderInvoicesLoading}
        orderInvoicesError={viewModel.orderInvoicesError}
        onNavigate={onNavigate}
      />
    )
  }

  if (viewModel.isOrdersListRoute) {
    return (
      <CustomerOrdersListPage
        orders={viewModel.orders}
        ordersLoading={viewModel.ordersLoading}
        ordersError={viewModel.ordersError}
        checkoutSyncActive={viewModel.checkoutSyncActive}
        onNavigate={onNavigate}
        onLogout={viewModel.handleLogout}
        onRetryOrders={viewModel.retryOrders}
      />
    )
  }

  return null
}
